import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import store from "./Redux/Store/Index";
import {Provider} from "react-redux";
import TagManager from 'react-gtm-module'
import {TAG_MANAGER_ID} from "./Redux/variables";
const tagManagerArgs = {
    gtmId: TAG_MANAGER_ID,
    dataLayerName: 'PageDataLayer'
}
TagManager.initialize(tagManagerArgs)
ReactDOM.render(
   <React.StrictMode>
       <Provider store={store}>
           <App />
       </Provider>
   </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
